import React from 'react';


import styles from './PopUpSaveDraft.module.scss';
import { Modal } from 'react-bootstrap';
import CloseButton from '../../CloseButton/CloseButton';

interface PopUpLoginProps {
  popupVisible: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const PopUpSaveDraft: React.FC<PopUpLoginProps> = ({ popupVisible, onClose, onAccept }) => {
  return (
    <Modal show={popupVisible} onHide={onClose} centered contentClassName={styles.rounded}>
      <Modal.Body className={`${styles.body} bg-light-gray p-4`}>
        <div className="d-flex justify-content-end w-100">
          <CloseButton callback={onClose} />
        </div>

        <div className="mb-4 text-center">
          <span className="text-16 fw-bold">You are saving a draft.</span>
        </div>

        <p className={`${styles.copy} text-16`}>
          Make sure all fields are correctly filled in before publishing your project. The sooner you publish your project, the better.
        </p>

        <p className={`${styles.copy} text-16`}>
          <i>
            In case you forget to publish your design, only complete drafts will be automatically submitted for the contest at the end of the upload phase, while incomplete drafts
            will be discarded.
          </i>
        </p>

        <div className="d-flex justify-content-center mt-4">
          <button className={`${styles.saveButton} btn-success rounded mb-3`} onClick={onAccept}>
            Save draft
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopUpSaveDraft;
